import React from "react";
import { Box, Typography, Card, CardContent, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import moment from "moment";

const PriceCard = ({
  name,
  price,
  description,
  selected,
  onSelect,
  color,
  active,
  borderColor,
  offerPrice,
  pricing,
}) => {
  const formatPrice = (price) => {
    return price ? parseFloat(price).toFixed(2) : "N/A";
  };

  return (
    <Card
      onClick={onSelect}
      sx={{
        backgroundColor: selected ? "#ffffff" : color,
        border: selected ? `2px solid ${borderColor}` : "1px solid #ccc",
        borderRadius: "8px",
        cursor: "pointer",
        position: "relative",
        boxShadow: selected ? "0px 4px 12px rgba(0, 0, 0, 0.1)" : "none",
        transition: "transform 0.3s ease, border-color 0.3s ease",
        "&:hover": {
          transform: "scale(1.05)",
          borderColor: selected ? borderColor : "#bbb",
          border: selected ? `2px solid ${borderColor}` : "1px solid #bbb",
        },
      }}
      aria-selected={selected}
    >
      {selected && (
        <IconButton
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "green",
          }}
          aria-label="Selected Plan"
        >
          <CheckCircleIcon />
        </IconButton>
      )}
      <CardContent>
        <Typography variant="h6" sx={{ color: "#000000" }}>
          {name}
        </Typography>

        {pricing?.is_offer_applicable &&
        moment.utc(pricing?.offer_valid_from).startOf("day") &&
        moment.utc(pricing?.offer_valid_to).endOf("day") &&
        new Date() >= moment.utc(pricing?.offer_valid_from).startOf("day") &&
        new Date() <= moment.utc(pricing?.offer_valid_to).endOf("day") ? (
          <>
            <Typography
              variant="h6"
              sx={{ color: "#000000", textDecoration: "line-through" }}
            >
              ₹ {formatPrice(pricing?.frequency_price)}
            </Typography>
            <Typography variant="h4" sx={{ color: "#000000" }}>
              ₹ {formatPrice(offerPrice)}
            </Typography>
          </>
        ) : (
          <Typography variant="h4" sx={{ color: "#000000" }}>
            ₹ {formatPrice(pricing?.frequency_price)}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PriceCard;
